import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      setErrorMessage: 'errorOverlay/setMessage',
      setSuccessMessage: 'successOverlay/setMessage',
    }),
  },
};
